module.exports = __webpack_public_path__ + "static/land-rover-defender-90-offroad-wales-9c82401c436bced5e23249abb80dc769.jpg";